import { ComponentProps } from "react"
import { CHAIN_ID } from "@mezo/sdk"
import { Block, GasFee, MatsCircle, ParagraphSmall } from "@mezo-org/mezo-clay"

import { IS_MEZO_MAINNET, MEZO_NETWORK } from "#/shared/constants"
import { networkUtils } from "#/shared/utils"
import { SwitchChainButton } from "#/ui/Button"

import StepperModalButton from "./StepperModalButton"

type SignTransactionModalButtonProps = {
  buttonLabel: string
  gasFee: string
  networkName?: string
} & ComponentProps<typeof StepperModalButton>

export default function SignTransactionModalButton({
  buttonLabel,
  gasFee,
  networkName,
  ...restProps
}: SignTransactionModalButtonProps) {
  return (
    <>
      <Block
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginLeft="scale600"
        marginRight="scale600"
        marginBottom="scale500"
      >
        <Block display="flex" alignItems="center">
          <GasFee size={12} color="contentTertiary" />
          <ParagraphSmall marginLeft="scale300" marginRight="scale600">
            {gasFee}
          </ParagraphSmall>
        </Block>
        <Block display="flex" alignItems="center">
          <MatsCircle size={14} />
          <ParagraphSmall
            marginLeft="scale100"
            style={{
              ...(!networkName && { textTransform: "capitalize" }),
            }}
          >
            {networkName ?? networkUtils.getMezoDAppLabel()}
          </ParagraphSmall>
        </Block>
      </Block>
      <SwitchChainButton
        chainId={CHAIN_ID[MEZO_NETWORK]}
        label={IS_MEZO_MAINNET ? "Mezo" : "Mezo Testnet"}
        size="large"
        shape="default"
        width="100%"
      >
        <StepperModalButton {...restProps}>{buttonLabel}</StepperModalButton>
      </SwitchChainButton>
    </>
  )
}
